<nb-card>
  <div class="summary">
    <div class="item">
      <div class="avatar">
        <ngx-view-user-display
          [user]="exerciseUser.author"
          [mode]="'avatar'"
        ></ngx-view-user-display>
      </div>

      <div>
        <ngx-view-user-display
          [user]="exerciseUser.author"
          [mode]="'name'"
        ></ngx-view-user-display>
        <ngx-view-time-ago
          [currentDate]="exerciseUser.createdOn"
        ></ngx-view-time-ago>

        <nb-actions size="none">
          <nb-action>
            <nb-icon
              [status]="
                exerciseUser.percentage >= exerciseUser.percentCompleted
                  ? 'success'
                  : 'danger'
              "
              class="action-icon"
              icon="percent-outline"
            ></nb-icon>
            <span> {{ exerciseUser.percentage }} </span>
          </nb-action>

          <nb-action>
            <nb-icon
              status="warning"
              class="action-icon"
              icon="clock-outline"
            ></nb-icon>
            <span>
              {{
                exerciseUser.timeSpent > 0 ? exerciseUser.timeSpent + " s" : "~"
              }}
            </span>
          </nb-action>
        </nb-actions>
      </div>
    </div>
  </div>
</nb-card>
